<template>
  <div class="page-main">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {

    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
</style>
